import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "fixed top-0 left-0 w-full text-primary-font z-1001" }
const _hoisted_2 = { class: "flex items-center justify-between px-2 h-15.5 lg:hidden bg-primary" }
const _hoisted_3 = { class: "flex flex-col items-center justify-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "text-center mt-0.5 text-[0.7rem] font-semibold text-white leading-tight" }
const _hoisted_6 = { class: "flex items-center gap-4" }
const _hoisted_7 = { class: "flex items-center text-sm font-bold text-white" }
const _hoisted_8 = { class: "bg-secondary text-primary-font lg:hidden" }
const _hoisted_9 = { class: "w-full h-7 overflow-hidden flex items-center justify-center" }
const _hoisted_10 = { class: "m-0 whitespace-nowrap text-xs font-bold animate-nav-marquee" }
const _hoisted_11 = { class: "hidden lg:flex w-full" }
const _hoisted_12 = { class: "flex flex-col items-center justify-center px-4 py-2 bg-primary w-65" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "mt-1 text-[0.7rem] font-semibold text-white text-center" }
const _hoisted_15 = { class: "flex-1 flex flex-col" }
const _hoisted_16 = { class: "flex items-center justify-between px-6 py-3 bg-secondary-background" }
const _hoisted_17 = { class: "flex items-center space-x-4 text-sm font-bold" }
const _hoisted_18 = { class: "flex items-center" }
const _hoisted_19 = { class: "flex items-center" }
const _hoisted_20 = { class: "flex items-center" }
const _hoisted_21 = { class: "flex items-center gap-2" }
const _hoisted_22 = { class: "bg-secondary text-sm text-primary-font font-bold py-1" }
const _hoisted_23 = { class: "relative w-full h-5 overflow-hidden" }
const _hoisted_24 = { class: "absolute m-0 whitespace-nowrap top-1/2 -translate-y-1/2 animate-nav-marquee" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LanguageButton = _resolveComponent("LanguageButton")!
  const _component_DocumentButton = _resolveComponent("DocumentButton")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", _hoisted_3, [
        (_ctx.logoSrc)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.logoSrc,
              alt: "logo",
              class: "h-8 w-auto object-contain"
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.safeT('auth.poweredByAskmebet')), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, [
          _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fas fa-money-bill mr-1 text-lg" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.formatCurrency(_ctx.displayWalletBalance)) + " " + _toDisplayString(_ctx.userCurrency || 'THB'), 1)
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "flex items-center justify-center text-2xl text-white cursor-pointer",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args)))
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("i", { class: "fas fa-bars text-2xl" }, null, -1)
        ]))])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.AnnounceList), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        (_ctx.logoSrc)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.logoSrc,
              alt: "logo",
              class: "h-11.25 w-47 object-contain"
            }, null, 8, _hoisted_13))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.safeT('auth.poweredByAskmebet')), 1)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("span", _hoisted_18, [
              _cache[4] || (_cache[4] = _createElementVNode("i", { class: "far fa-user-circle mr-1" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.displayUsername), 1)
            ]),
            _createElementVNode("span", _hoisted_19, [
              _cache[5] || (_cache[5] = _createElementVNode("i", { class: "fas fa-briefcase mr-1" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.displayRole), 1)
            ]),
            _createElementVNode("span", _hoisted_20, [
              _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fas fa-money-bill mr-1" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.formatCurrency(_ctx.displayWalletBalance)) + " " + _toDisplayString(_ctx.userCurrency ? _ctx.userCurrency : 'THB'), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_LanguageButton),
            _createVNode(_component_DocumentButton),
            _createElementVNode("button", {
              type: "button",
              class: "flex items-center text-sm font-semibold hover:opacity-80 transition cursor-pointer hover:text-red-500",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onLogout()))
            }, [
              _cache[7] || (_cache[7] = _createElementVNode("i", { class: "fas fa-sign-out-alt mr-1" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.safeT('general.signout')), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.AnnounceList), 1)
          ])
        ])
      ])
    ])
  ]))
}